import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LockerHelper {

    dataSource: any[] = [];
    public lockerSubject = new BehaviorSubject<any>(this.dataSource);

    constructor(private _snackBar: MatSnackBar) {
        this.lockerSubject.next(true)
    }
    
    openSnackBar(message: string, action: string = '', duration: number = 3): void {
        this._snackBar.open(message, action, {duration: duration * 1000});
    }
  
}